import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type MembersWithLeastPhotoCardsResponse =
  paths['/api/v1/members/least_photo_cards']['get']['responses'][200]['content']['application/json']['members'];

export async function getMembersWithLeastPhotoCards(): Promise<MembersWithLeastPhotoCardsResponse> {
  const { data, error } = await client.GET('/api/v1/members/least_photo_cards', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getMembersWithLeastPhotoCards');
  return data.members;
}
